import { Box, Text, Flex } from "@chakra-ui/react";

import InfoIcon from "./InfoIcon";
import ErrorIcon from "./ErrorIcon";
import WarningIcon from "./WarningIcon";

interface AlertProps {
  type: string;
  message: string | null;
  showMessage: boolean;
}

function Alert({ type, message, showMessage }: AlertProps) {
  let color;
  let backgroundColor;
  let icon;
  switch (type) {
    case "info":
      color = "brand.alert.infoColor";
      backgroundColor = "brand.alert.infoBgColor";
      icon = <InfoIcon />;
      break;
    case "error":
      color = "brand.alert.errorColor";
      backgroundColor = "brand.alert.errorBgColor";
      icon = <ErrorIcon />;
      break;
    case "warning":
      color = "brand.alert.warningColor";
      backgroundColor = "brand.alert.warningBgColor";
      icon = <WarningIcon />;
      break;
  }

  return showMessage && message ? (
    <Flex
      color={color}
      backgroundColor={backgroundColor}
      fontSize="14px"
      w="100%"
      borderRadius="8px"
      alignItems="center"
      py="12px"
      px="6px"
    >
      <Box mx="10px" as="span" position="relative" top="-2px">
        {icon}
      </Box>
      <Text m="0" p="0">
        {message}
      </Text>
    </Flex>
  ) : null;
}

export default Alert;
